/**
 * This constant file will be used to maintain features
 * which are in progress/ not deployed to prod
 */
export const FEATURES = {
    TK_BACKDATING: "TKBackdating",
    BULK_JOB: "bulkJob",
    INVOICE_LINE_ITEM_DISCOUNT: "invoiceLineItemDiscount",
    SITE_FEEDBACK: "isSiteFeedbackEnabled",
    ENABLE_MULTI_PRODUCT: "enableMultiProduct",
    INVOICE_PRE_VALIDATION: "enableInvoicePreValidation",
    BULK_LINE_ITEM_UPDATE: "bulkLineItemUpdate",
    ENABLE_BUDGET_INTAKE: "enableBudgetIntake",
    ENABLE_INVOICE_HOLD: "enableInvoiceHold"
}
